import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

interface UpgradePromptButtonProps {
  variant?: 'header' | 'sidebar';
  className?: string;
}

const UpgradePromptButton: React.FC<UpgradePromptButtonProps> = ({ 
  variant = 'header', 
  className 
}) => {
  const navigate = useNavigate();

  const handleUpgradeClick = () => {
    navigate('/admin/business/subscription');
  };

  if (variant === 'sidebar') {
    return (
      <Button
        onClick={handleUpgradeClick}
        className={cn(
          "w-full justify-start gap-2 text-white transition-all duration-300",
          "bg-gradient-to-r from-purple-600 to-pink-600",
          "hover:from-purple-700 hover:to-pink-700",
          "shadow-md hover:shadow-lg",
          "group relative overflow-hidden",
          className
        )}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-purple-400/20 to-pink-400/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <Sparkles className="h-5 w-5 animate-pulse" />
        <span className="font-medium">Unlock Business</span>
      </Button>
    );
  }

  // Header variant
  return (
    <Button
      onClick={handleUpgradeClick}
      size="sm"
      className={cn(
        "flex items-center gap-1.5 text-white transition-all duration-300",
        "bg-gradient-to-r from-purple-600 to-pink-600",
        "hover:from-purple-700 hover:to-pink-700",
        "shadow-sm hover:shadow-md",
        "group relative overflow-hidden",
        className
      )}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-purple-400/20 to-pink-400/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      <Sparkles className="h-4 w-4 animate-pulse" />
      <span className="font-medium">Unlock Business</span>
    </Button>
  );
};

export default UpgradePromptButton;